import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";

export default function getChapterDuration(state, ownProps) {
  if (typeof ownProps.chapterId === "undefined") {
    return 0;
  }

  const chapterEntity = getChapterEntity(state, ownProps);
  if (!chapterEntity) {
    return 0;
  }

  if (chapterEntity.type === "pathfinder") {
    if (chapterEntity.introductionVideo) {
      return chapterEntity.introductionVideo.duration;
    }

    return 0;
  }

  return chapterEntity.duration;
}
